(function () {
  if (window.TopRealMotion) return;
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  var KF = {
    up: [{ opacity: 0, transform: 'translateY(40px)' }, { opacity: 1, transform: 'none' }],
    fade: [{ opacity: 0 }, { opacity: 1 }],
    line: [{ transform: 'scaleX(0)', transformOrigin: '0 50%' }, { transform: 'scaleX(1)', transformOrigin: '0 50%' }],
    mask: [{ opacity: 0, transform: 'translateY(0.4em)', clipPath: 'inset(100% -10% -30% -10%)' }, { opacity: 1, transform: 'none', clipPath: 'inset(-30% -10% -30% -10%)' }],
    clip: [{ clipPath: 'inset(100% 0% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)' }],
    zoom: [{ transform: 'scale(1.14)' }, { transform: 'none' }]
  };
  var DUR = { up: 950, fade: 900, line: 1000, mask: 1100, clip: 1300, zoom: 2400 };
  var mounts = new WeakMap();

  function mount(root) {
    root = root || document.body;
    if (mounts.has(root)) return mounts.get(root);
    var boot = window.TopRealMotionBoot;
    var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
    var rm = !Element.prototype.animate || document.body.hasAttribute('data-tr-reduce-motion') || mq('(prefers-reduced-motion: reduce)');
    var fine = mq('(hover: hover) and (pointer: fine)');
    var wired = new WeakSet(), seen = new WeakSet(), state = new Map(), pending = new Set(), styles = new WeakMap(), px = [], offs = [];
    var hero = null, heroBg = null, heroFg = null, bar = null, raf = 0, scanT = 0, scanned = false;

    function writeStyle(el, property, value) {
      var previous = styles.get(el);
      if (!previous) { previous = {}; styles.set(el, previous); }
      if (previous[property] === value) return;
      previous[property] = value;
      el.style[property] = value;
    }

    function prep(el, kind) {
      var k = KF[kind] ? kind : 'up', out = [];
      var a = el.animate(KF[k], { duration: DUR[k], easing: k === 'zoom' ? 'cubic-bezier(.16,1,.3,1)' : EASE, fill: 'backwards' });
      a.pause(); out.push(a);
      if (k === 'clip') {
        var img = el.querySelector('img,[role="img"]');
        if (img) { var b = img.animate(KF.zoom, { duration: 1800, easing: EASE, fill: 'backwards' }); b.pause(); out.push(b); }
      }
      return out;
    }
    function register(target, list) {
      // A late script must not hide content the fail-safe has already revealed.
      if ((scanned || boot && boot.expired) && target.getBoundingClientRect().top < window.innerHeight) return;
      var s = state.get(target);
      if (!s) { s = { done: false, items: [], n: 0 }; state.set(target, s); pending.add(target); }
      list.forEach(function (it) {
        var counts = [].slice.call(it.el.querySelectorAll('[data-count]'));
        if (it.el.hasAttribute('data-count')) counts.push(it.el);
        s.items.push({ anims: prep(it.el, it.kind), delay: it.delay, counts: counts });
      });
    }
    function trigger(target) {
      var s = state.get(target); pending.delete(target);
      if (!s || s.done) return; s.done = true;
      s.items.forEach(function (it) {
        it.anims.forEach(function (a) { a.effect.updateTiming({ delay: it.delay }); a.play(); });
        it.counts.forEach(function (c) { countUp(c, it.delay + 200); });
      });
    }
    function countUp(el, delay) {
      var tn = el.firstChild; if (!tn || tn.nodeType !== 3) return;
      var raw = tn.nodeValue, m = /^(\d+)([\s\S]*)$/.exec(raw); if (!m) return;
      var end = +m[1], from = end > 100 ? end - 30 : 0, t0 = performance.now() + delay, suf = m[2];
      tn.nodeValue = from + suf;
      (function tick(now) {
        var cur = String(tn.nodeValue);
        if (suf && cur.slice(-suf.length) !== suf) return;
        var p = Math.min(1, Math.max(0, (now - t0) / 1500)), e = 1 - Math.pow(1 - p, 4);
        tn.nodeValue = p < 1 ? Math.round(from + (end - from) * e) + suf : raw;
        if (p < 1) requestAnimationFrame(tick);
      })(performance.now());
    }
    function itemsOf(c) {
      var out = [];
      (function walk(n) {
        for (var i = 0; i < n.children.length; i++) {
          var ch = n.children[i];
          if (/^SC-/.test(ch.tagName) || getComputedStyle(ch).display === 'contents') walk(ch); else out.push(ch);
        }
      })(c);
      return out;
    }
    function tilt(el) {
      var img = el.querySelector('[data-tilt-img]');
      if (img) img.style.transition = 'transform .6s ' + EASE;
      function mv(e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(1200px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 7).toFixed(2) + 'deg) translateY(-6px)';
        if (img) img.style.transform = 'translate3d(' + (-x * 18).toFixed(1) + 'px,' + (-y * 12).toFixed(1) + 'px,0) scale(1.04)';
      }
      function lv() { el.style.transform = ''; if (img) img.style.transform = ''; }
      el.addEventListener('pointermove', mv); el.addEventListener('pointerleave', lv);
      offs.push(function () { el.removeEventListener('pointermove', mv); el.removeEventListener('pointerleave', lv); lv(); });
    }
    function scan() {
      state.forEach(function(s, element) { if (!element.isConnected) { state.delete(element); pending.delete(element); } });
      scanT = 0;
      if (!rm) {
        root.querySelectorAll('[data-rv-stagger]').forEach(function (c) {
          var items = itemsOf(c).filter(function (el) { return !wired.has(el); });
          if (!items.length) return;
          items.forEach(function (el) { wired.add(el); });
          var s = state.get(c); if (s && s.done) return;
          var base = +c.getAttribute('data-rv-delay') || 0, step = +(c.getAttribute('data-rv-step') || 90);
          var kind = c.getAttribute('data-rv-stagger') || 'up', n0 = s ? s.n : 0;
          register(c, items.map(function (el, i) { return { el: el, kind: el.getAttribute('data-rv') || kind, delay: base + (n0 + i) * step }; }));
          if (state.has(c)) state.get(c).n = n0 + items.length;
        });
        root.querySelectorAll('[data-rv]').forEach(function (el) {
          if (wired.has(el)) return; wired.add(el);
          register(el, [{ el: el, kind: el.getAttribute('data-rv'), delay: +el.getAttribute('data-rv-delay') || 0 }]);
        });
        root.querySelectorAll('[data-px],[data-sx]').forEach(function (el) {
          if (seen.has(el)) return; seen.add(el);
          px.push({ el: el, y: parseFloat(el.getAttribute('data-px')) || 0, x: parseFloat(el.getAttribute('data-sx')) || 0 });
        });
        if (fine) root.querySelectorAll('[data-tilt]').forEach(function (el) { if (!seen.has(el)) { seen.add(el); tilt(el); } });
        hero = root.querySelector('[data-hero]'); heroBg = root.querySelector('[data-hero-bg]'); heroFg = root.querySelector('[data-hero-fg]');
      }
      bar = root.querySelector('[data-progress]');
      px = px.filter(function (p) { return p.el.isConnected; });
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      frame();
      scanned = true;
    }
    function frame() {
      raf = 0;
      var vh = window.innerHeight, ready = [], positions = [], heroPosition = null, progress = null;
      pending.forEach(function (t) {
        if (!t.isConnected) { pending.delete(t); return; }
        if (t.getBoundingClientRect().top < vh * 0.88) ready.push(t);
      });
      px.forEach(function (p) {
        var host = p.el.parentElement; if (!host) return;
        var r = host.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return;
        var q = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2)));
        positions.push({ el: p.el, value: (q * p.x * r.width).toFixed(1) + 'px ' + (-q * p.y * r.height).toFixed(1) + 'px' });
      });
      if (hero && (heroBg || heroFg)) {
        var h = hero.offsetHeight || vh, y = Math.max(0, Math.min(h, -hero.getBoundingClientRect().top)), k = y / h;
        heroPosition = { background: '0px ' + (y * 0.35).toFixed(1) + 'px', scale: (1 + k * 0.1).toFixed(4), foreground: '0px ' + (-y * 0.2).toFixed(1) + 'px', opacity: Math.max(0, 1 - k * 1.5).toFixed(3) };
      }
      if (bar) {
        var max = document.documentElement.scrollHeight - vh;
        progress = (max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0).toFixed(4) + ' 1';
      }
      ready.forEach(trigger);
      positions.forEach(function (p) { writeStyle(p.el, 'translate', p.value); });
      if (heroPosition) {
        if (heroBg) { writeStyle(heroBg, 'translate', heroPosition.background); writeStyle(heroBg, 'scale', heroPosition.scale); }
        if (heroFg) { writeStyle(heroFg, 'translate', heroPosition.foreground); writeStyle(heroFg, 'opacity', heroPosition.opacity); }
      }
      if (bar) writeStyle(bar, 'scale', progress);
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(frame); }
    function finishAll() {
      state.forEach(function (s, t) { trigger(t); s.items.forEach(function (it) { it.anims.forEach(function (a) { try { a.finish(); } catch (e) {} }); }); });
    }
    var mo = new MutationObserver(function () { if (!scanT) scanT = setTimeout(scan, 60); });
    mo.observe(root, { childList: true, subtree: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('beforeprint', finishAll);
    var safety = setInterval(schedule, 800);
    setTimeout(function () { clearInterval(safety); }, 8000);
    scan();
    if (boot) boot.release('tr-motion-pending');
    var dispose = function () {
      mo.disconnect(); clearInterval(safety); clearTimeout(scanT); if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule); window.removeEventListener('beforeprint', finishAll);
      finishAll(); offs.forEach(function (f) { f(); });
      mounts.delete(root);
    };
    mounts.set(root, dispose);
    return dispose;
  }

  window.TopRealMotion = { mount: mount };
  function auto() { if (!window.__trMotionOff) window.__trMotionOff = mount(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();
})();
